export default __webpack_public_path__ + "static/media/informationImage3.0357ba6e.svg";